import React from "react";
import { NavLink } from "react-router-dom";
import t from "../i18n";
// import { AuthService } from "./auth/auth-service";
// import { createHashHistory } from "history";
declare type DesktopMenuProps = {
    userName: string;
    onLogoutClicked: () => void;
}
export const DesktopMenu = (props: DesktopMenuProps) => {
    const [visible, setVisible] = React.useState(false);
    const dropDownMenu = React.useRef<HTMLUListElement>(null);
    React.useEffect(() => {
        if (!visible) return;
        const onDocumentClick = (event: Event) => {
            if (!dropDownMenu.current) return;
            const target = event.target as HTMLElement;
            const langDropdown = target.closest(".dropdown-menu-source");
            if (!langDropdown) {
                setVisible(false);
            }
        }
        document.addEventListener("click", onDocumentClick);
        return () => {
            document.removeEventListener("click", onDocumentClick);
        }

    }, [visible]);
    const showDropdown = () => {
        setVisible(true);
    }
    const hideDropdown = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.stopPropagation();
        setVisible(false);
    }
    const onLogoutClicked = (e: React.MouseEvent<HTMLAnchorElement>) => {
        hideDropdown(e);
        props.onLogoutClicked?.();
    }
    return <div className="desktop-menu d-none d-md-flex flex-column align-items-left"
        style={{ marginLeft: "auto" }}
        onClick={showDropdown}>
        <div>
            <span className="welcome-user">{props.userName}</span>
        </div>
        <div className="dropdown-menu-source">
            <span style={{ fontSize: 17 }}>{t.menu("account")}</span>
            <span className="caret" />
        </div>
        {visible ?
            <ul className="desktop-menu-dropdown" ref={dropDownMenu} style={{ display: "block" }}>
                <li><NavLink onClick={hideDropdown} to="/order-history">{t.menu("order_history")}</NavLink></li>
                <li><NavLink onClick={hideDropdown} to="/tickets">{t.menu("support")}</NavLink></li>
                <li><NavLink onClick={hideDropdown} to="/contact-list">{t.menu("contact_list")}</NavLink></li>
                <li><NavLink onClick={hideDropdown} to="/change-password">{t.menu("change_password")}</NavLink></li>
                <li><NavLink onClick={hideDropdown} to="/reward-points">{t.menu("reward_points")}</NavLink></li>
                {/* <li><NavLink onClick={this.hideDropdown} to="/manage-payments">{t.menu("manage-payments")}</NavLink></li> */}
                <li><a href="javascript:void(0)" onClick={onLogoutClicked}>{t.menu("logout")}</a></li>
            </ul> : null}
    </div>
}